const coreMathsQuestions = [


{
  question: "Points A(1,2) and B(5,2) are shown on the diagram. Find AB.",
  image: "/images/coord1.png",
  options: ["2", "3", "4", "5"],
  answer: "4"
},

{
  question: "Find the midpoint of A(2,4) and B(6,8).",
  image: "/images/coord2.png",
  options: ["(4,6)", "(3,5)", "(5,7)", "(2,6)"],
  answer: "(4,6)"
},

{
  question: "Find gradient of line through (1,2) and (3,6).",
  image: "/images/coord3.png",
  options: ["1", "2", "3", "4"],
  answer: "2"
},

{
  question: "Find equation of line passing through (0,3) with gradient 2.",
  image: "/images/coord4.png",
  options: ["y=2x+3", "y=3x+2", "y=2x-3", "y=x+3"],
  answer: "y=2x+3"
},

{
  question: "Find distance between (2,3) and (6,7).",
  image: "/images/coord5.png",
  options: ["4", "5.66", "6", "7"],
  answer: "5.66"
},

{
  question: "Find x-intercept of y = 2x - 4.",
  image: "/images/coord6.png",
  options: ["1", "2", "3", "4"],
  answer: "2"
},

{
  question: "Two lines intersect at (3,2). Identify intersection.",
  image: "/images/coord7.png",
  options: ["(3,2)", "(2,3)", "(1,1)", "(4,2)"],
  answer: "(3,2)"
},

{
  question: "Find gradient of horizontal line.",
  image: "/images/coord8.png",
  options: ["0", "1", "-1", "undefined"],
  answer: "0"
},

{
  question: "Find gradient of vertical line.",
  image: "/images/coord9.png",
  options: ["0", "undefined", "1", "-1"],
  answer: "undefined"
},

{
  question: "Find midpoint of (0,0) and (4,4).",
  image: "/images/coord10.png",
  options: ["(2,2)", "(3,3)", "(1,1)", "(4,4)"],
  answer: "(2,2)"
},


{
  question: "Right triangle has opposite = 3, hypotenuse = 5. Find sin θ.",
  image: "/images/trig1.png",
  options: ["0.6", "0.5", "0.4", "0.8"],
  answer: "0.6"
},

{
  question: "Adjacent = 4, hypotenuse = 5. Find cos θ.",
  image: "/images/trig2.png",
  options: ["0.8", "0.6", "0.5", "0.4"],
  answer: "0.8"
},

{
  question: "Opp = 3, Adj = 4. Find tan θ.",
  image: "/images/trig3.png",
  options: ["3/4", "4/3", "1/2", "2/3"],
  answer: "3/4"
},

{
  question: "Find hypotenuse when sides are 6 and 8.",
  image: "/images/trig4.png",
  options: ["10", "12", "14", "16"],
  answer: "10"
},

{
  question: "Angle of elevation = 30°, distance = 10m. Find height.",
  image: "/images/trig5.png",
  options: ["5m", "6m", "7m", "8m"],
  answer: "5m"
},

{
  question: "Angle of elevation = 45°, distance = 10m. Find height.",
  image: "/images/trig6.png",
  options: ["10m", "15m", "5m", "20m"],
  answer: "10m"
},

{
  question: "Find sin 90°.",
  image: "/images/trig7.png",
  options: ["1", "0", "0.5", "2"],
  answer: "1"
},

{
  question: "Find cos 0°.",
  image: "/images/trig8.png",
  options: ["1", "0", "0.5", "-1"],
  answer: "1"
},

{
  question: "Find tan 45°.",
  image: "/images/trig9.png",
  options: ["1", "0", "2", "0.5"],
  answer: "1"
},

{
  question: "Find sin 30°.",
  image: "/images/trig10.png",
  options: ["0.5", "1", "0.25", "0.75"],
  answer: "0.5"
},


{
  question: "Angle at center is 60°. Find angle at circumference.",
  image: "/images/circle1.png",
  options: ["30°", "60°", "90°", "120°"],
  answer: "30°"
},

{
  question: "Opposite angles in cyclic quadrilateral sum to?",
  image: "/images/circle2.png",
  options: ["180°", "90°", "360°", "270°"],
  answer: "180°"
},

{
  question: "Angle between radius and tangent is?",
  image: "/images/circle3.png",
  options: ["90°", "60°", "45°", "180°"],
  answer: "90°"
},

{
  question: "Angles in same segment are?",
  image: "/images/circle4.png",
  options: ["equal", "opposite", "supplementary", "random"],
  answer: "equal"
},

{
  question: "Angle in semicircle is?",
  image: "/images/circle5.png",
  options: ["90°", "60°", "45°", "30°"],
  answer: "90°"
},


{
  question: "Volume of cube side 3cm.",
  image: "/images/volume1.png",
  options: ["27", "9", "18", "36"],
  answer: "27"
},

{
  question: "Volume of cuboid 2×3×4.",
  image: "/images/volume2.png",
  options: ["24", "12", "18", "20"],
  answer: "24"
},

{
  question: "Volume of cylinder r=7, h=10.",
  image: "/images/volume3.png",
  options: ["1540", "1400", "1600", "1500"],
  answer: "1540"
},

{
  question: "Volume of sphere r=3.",
  image: "/images/volume4.png",
  options: ["113.1", "100", "120", "110"],
  answer: "113.1"
},

{
  question: "Volume of cone r=3, h=4.",
  image: "/images/volume5.png",
  options: ["37.7", "40", "35", "30"],
  answer: "37.7"
},


{
  question: "Vector AB = (2,3), BC = (1,1). Find AC.",
  image: "/images/vector1.png",
  options: ["(3,4)", "(2,4)", "(1,2)", "(4,5)"],
  answer: "(3,4)"
},

{
  question: "Find magnitude of vector (3,4).",
  image: "/images/vector2.png",
  options: ["5", "6", "7", "4"],
  answer: "5"
},

{
  question: "Resultant vector is?",
  image: "/images/vector3.png",
  options: ["Diagonal", "Side", "Angle", "Midpoint"],
  answer: "Diagonal"
},


{
  question: "Translation right 2 units.",
  image: "/images/trans1.png",
  options: ["(2,0)", "(0,2)", "(-2,0)", "(0,-2)"],
  answer: "(2,0)"
},

{
  question: "Reflection in x-axis changes?",
  image: "/images/trans2.png",
  options: ["y sign", "x sign", "both", "none"],
  answer: "y sign"
},

{
  question: "Rotation 90° clockwise gives?",
  image: "/images/trans3.png",
  options: ["(y,-x)", "(-y,x)", "(x,y)", "(-x,-y)"],
  answer: "(y,-x)"
},

/* ================= PROBABILITY ================= */

{
  question: "Probability of head in fair coin.",
  image: "/images/prob1.png",
  options: ["1/2", "1", "0", "2"],
  answer: "1/2"
},

{
  question: "Probability of 3 on fair die.",
  image: "/images/prob2.png",
  options: ["1/6", "1/3", "1/2", "1"],
  answer: "1/6"
},

{
  question: "Total probability = ?",
  image: "/images/prob3.png",
  options: ["1", "0", "2", "0.5"],
  answer: "1"
},

{
  question: "The diagram shows a cumulative frequency curve (ogive). Estimate the median.",
  image: "/images/math_shs9.png",
  options: ["40", "50", "60", "70"],
  answer: "50"
},

{
  question: "The diagram shows a box plot. What is the interquartile range (IQR)?",
  image: "/images/math_shs10.png",
  options: ["10", "20", "30", "40"],
  answer: "20"
},

{
  question: "The diagram shows a triangle and its image after a transformation on a grid. What type of transformation is shown?",
  image: "/images/math_shs11.png",
  options: ["Rotation", "Reflection", "Translation", "Enlargement"],
  answer: "Translation"
},

{
  question: "The diagram shows a cube. How many edges does the cube have?",
  image: "/images/math_shs12.png",
  options: ["8", "10", "12", "14"],
  answer: "12"
},

{
  question: "The diagram shows a region of points equidistant from two points A and B. What is the locus?",
  image: "/images/math_shs13.png",
  options: ["Circle", "Perpendicular bisector", "Angle bisector", "Straight line"],
  answer: "Perpendicular bisector"
},

{
  question: "The diagram shows a graph of the inequality x + y ≤ 6. Which region is correct?",
  image: "/images/math_shs14.png",
  options: ["Region above the line", "Region below the line", "On the line only", "Outside the graph"],
  answer: "Region below the line"
},

{
  question: "The diagram shows a feasible region for a linear programming problem. At which point is the maximum value obtained?",
  image: "/images/math_shs15.png",
  options: ["A", "B", "C", "D"],
  answer: "C"
},

{
  question: "The diagram shows the net of a cube. How many faces will the cube have when folded?",
  image: "/images/math_shs16.png",
  options: ["4", "5", "6", "8"],
  answer: "6"
},

{
  question: "The diagram shows points plotted for a sequence. What type of sequence is illustrated?",
  image: "/images/math_shs17.png",
  options: ["Arithmetic", "Geometric", "Constant", "Quadratic"],
  answer: "Arithmetic"
},

{
  question: "The diagram shows the graph of y = 1/x. What type of graph is this?",
  image: "/images/math_shs18.png",
  options: ["Parabola", "Straight line", "Hyperbola", "Circle"],
  answer: "Hyperbola"
},

{
  question: "A set has 4 elements. How many subsets does it have?",
  options: ["8", "16", "32", "4"],
  answer: "16"
},
{
  question: "If A = {1,2,3,4} and B = {3,4,5,6}, find A ∩ B.",
  options: ["{3,4}", "{1,2}", "{5,6}", "{1,6}"],
  answer: "{3,4}"
},
{
  question: "If A = {1,2,3} and B = {2,3,4}, find A ∪ B.",
  options: ["{1,2,3,4}", "{2,3}", "{1,4}", "{3,4}"],
  answer: "{1,2,3,4}"
},
{
  question: "In a class of 50 students, 30 study Maths, 25 study Science, and 10 study both. How many study neither?",
  options: ["5", "10", "15", "20"],
  answer: "5"
},
{
  question: "If n(A) = 20, n(B) = 15 and n(A ∩ B) = 5, find n(A ∪ B).",
  options: ["30", "25", "35", "20"],
  answer: "30"
},
{
  question: "Which of the following is irrational?",
  options: ["0.125", "√3", "3/5", "0.75"],
  answer: "√3"
},
{
  question: "Arrange in ascending order: 0.2, 1/4, 30%.",
  options: ["0.2, 1/4, 30%", "30%, 0.2, 1/4", "1/4, 0.2, 30%", "0.2, 30%, 1/4"],
  answer: "0.2, 1/4, 30%"
},
{
  question: "Round 36.478 to 2 decimal places.",
  options: ["36.47", "36.48", "36.46", "36.49"],
  answer: "36.48"
},
{
  question: "Express 0.666... as a fraction.",
  options: ["2/3", "1/3", "3/4", "5/6"],
  answer: "2/3"
},
{
  question: "Write 0.0045 in standard form.",
  options: ["4.5 × 10⁻³", "45 × 10⁻⁴", "4.5 × 10⁻⁴", "0.45 × 10⁻²"],
  answer: "4.5 × 10⁻³"
},
{
  question: "Evaluate: (2 × 10³)(3 × 10²).",
  options: ["6 × 10⁵", "5 × 10⁵", "6 × 10⁶", "6 × 10⁴"],
  answer: "6 × 10⁵"
},
{
  question: "Find the value of x if 3x + 7 = 22.",
  options: ["5", "4", "3", "6"],
  answer: "5"
},
{
  question: "Simplify: 5x − 2x + 3x.",
  options: ["6x", "5x", "4x", "3x"],
  answer: "6x"
},
{
  question: "Express 45% as a decimal.",
  options: ["0.45", "4.5", "0.045", "45"],
  answer: "0.45"
},
{
  question: "Find the reciprocal of 5/8.",
  options: ["8/5", "5/8", "3/8", "8/3"],
  answer: "8/5"
},
{
  question: "Evaluate: 7² − 3².",
  options: ["40", "16", "49", "28"],
  answer: "40"
},
{
  question: "Simplify: (4 × 10⁴) ÷ (2 × 10²).",
  options: ["2 × 10²", "2 × 10³", "8 × 10²", "2 × 10⁶"],
  answer: "2 × 10²"
},
{
  question: "Find the value of x if x² = 64.",
  options: ["±8", "8 only", "-8 only", "16"],
  answer: "±8"
},
{
  question: "Convert 0.125 to a fraction.",
  options: ["1/8", "1/4", "3/8", "1/2"],
  answer: "1/8"
},
{
  question: "Arrange in descending order: 1/2, 0.6, 55%.",
  options: ["0.6, 55%, 1/2", "1/2, 0.6, 55%", "55%, 0.6, 1/2", "0.6, 1/2, 55%"],
  answer: "0.6, 55%, 1/2"
},

{
  question: "Expand: (x + 3)(x − 5).",
  options: ["x² − 2x − 15", "x² + 2x − 15", "x² − 15", "x² − 8x + 15"],
  answer: "x² − 2x − 15"
},
{
  question: "Factorize: x² + 7x + 10.",
  options: ["(x+5)(x+2)", "(x+10)(x+1)", "(x+7)(x+3)", "(x+2)(x+3)"],
  answer: "(x+5)(x+2)"
},
{
  question: "Simplify: (3x²)(2x³).",
  options: ["6x⁵", "5x⁶", "6x⁶", "5x⁵"],
  answer: "6x⁵"
},
{
  question: "Solve: 2x − 5 = 9.",
  options: ["7", "6", "5", "4"],
  answer: "7"
},
{
  question: "Solve: 3x + 4 = 2x + 9.",
  options: ["5", "4", "3", "6"],
  answer: "5"
},
{
  question: "Simplify: (x² − 16)/(x − 4).",
  options: ["x + 4", "x − 4", "x² − 4", "x + 2"],
  answer: "x + 4"
},
{
  question: "If x + 1/x = 5, find x² + 1/x².",
  options: ["23", "25", "21", "20"],
  answer: "23"
},
{
  question: "Factorize completely: 2x² − 8.",
  options: ["2(x−2)(x+2)", "(2x−4)(x+2)", "2(x−4)(x+1)", "(x−2)(x+4)"],
  answer: "2(x−2)(x+2)"
},
{
  question: "Simplify: √49.",
  options: ["7", "14", "21", "6"],
  answer: "7"
},
{
  question: "Simplify: √75.",
  options: ["5√3", "3√5", "15√5", "25√3"],
  answer: "5√3"
},
{
  question: "Simplify: √18 + √8.",
  options: ["5√2", "4√2", "6√2", "3√2"],
  answer: "5√2"
},
{
  question: "Evaluate: (√5)(√20).",
  options: ["10", "25", "5", "20"],
  answer: "10"
},
{
  question: "Rationalize: 1/√2.",
  options: ["√2/2", "2√2", "1/2√2", "√2"],
  answer: "√2/2"
},
{
  question: "Simplify: (√7)².",
  options: ["7", "14", "49", "√7"],
  answer: "7"
},
{
  question: "Convert 13 (base 10) to base 2.",
  options: ["1101", "1011", "1110", "1001"],
  answer: "1101"
},
{
  question: "Convert 1101₂ to base 10.",
  options: ["13", "11", "12", "14"],
  answer: "13"
},
{
  question: "Evaluate: 21₃ + 12₃.",
  options: ["110₃", "100₃", "102₃", "111₃"],
  answer: "110₃"
},
{
  question: "Convert 32₄ to base 10.",
  options: ["14", "12", "10", "16"],
  answer: "14"
},
{
  question: "Find x if 21ₓ = 7₁₀.",
  options: ["5", "6", "4", "3"],
  answer: "5"
},
{
  question: "Evaluate: 101₂ × 10₂.",
  options: ["1010₂", "1001₂", "1110₂", "1100₂"],
  answer: "1010₂"
},

{
  question: "Which of the following relations is a function?",
  options: ["One-to-many", "Many-to-many", "Many-to-one", "None"],
  answer: "Many-to-one"
},
{
  question: "Find f(3) if f(x) = 2x + 5.",
  options: ["11", "10", "9", "8"],
  answer: "11"
},
{
  question: "If f(x) = x² − 1, find f(−2).",
  options: ["3", "-3", "5", "-5"],
  answer: "3"
},
{
  question: "Find the range of {(1,2), (2,3), (3,4)}.",
  options: ["{1,2,3}", "{2,3,4}", "{1,4}", "{3,4}"],
  answer: "{2,3,4}"
},
{
  question: "Find the gradient of a line passing through (2,3) and (6,11).",
  options: ["2", "3", "4", "1"],
  answer: "2"
},
{
  question: "Find the gradient of y = 4x − 7.",
  options: ["4", "-7", "7", "3"],
  answer: "4"
},
{
  question: "Find the equation of a line with gradient 3 and y-intercept 2.",
  options: ["y = 3x + 2", "y = 2x + 3", "y = 3x − 2", "y = x + 2"],
  answer: "y = 3x + 2"
},
{
  question: "Find the distance between (1,2) and (4,6).",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "Find the midpoint of (2,6) and (8,10).",
  options: ["(5,8)", "(4,7)", "(6,9)", "(5,7)"],
  answer: "(5,8)"
},
{
  question: "Find the value of y if y = 2x − 3 and x = 4.",
  options: ["5", "6", "4", "3"],
  answer: "5"
},
{
  question: "If f(x) = 3x − 2, find x when f(x) = 10.",
  options: ["4", "3", "2", "5"],
  answer: "4"
},
{
  question: "Find the gradient between (−1,2) and (3,10).",
  options: ["2", "3", "4", "1"],
  answer: "2"
},
{
  question: "Which of the following is NOT a function?",
  options: ["y = x²", "y = 2x + 3", "x² + y² = 4", "y = 5x"],
  answer: "x² + y² = 4"
},
{
  question: "Find the equation of a line passing through (0,5) with gradient 2.",
  options: ["y = 2x + 5", "y = 5x + 2", "y = 2x − 5", "y = x + 5"],
  answer: "y = 2x + 5"
},
{
  question: "Find the distance between (−2,−3) and (1,1).",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "Find the midpoint of (−2,4) and (6,2).",
  options: ["(2,3)", "(4,3)", "(2,2)", "(3,2)"],
  answer: "(2,3)"
},
{
  question: "If f(x) = x² + 2x, find f(1).",
  options: ["3", "2", "1", "4"],
  answer: "3"
},
{
  question: "Find the gradient of a horizontal line.",
  options: ["0", "1", "Undefined", "-1"],
  answer: "0"
},
{
  question: "Find the gradient of a vertical line.",
  options: ["Undefined", "0", "1", "-1"],
  answer: "Undefined"
},
{
  question: "Find the equation of a line with gradient −2 and y-intercept 1.",
  options: ["y = -2x + 1", "y = 2x + 1", "y = -2x - 1", "y = x - 2"],
  answer: "y = -2x + 1"
},

{
  question: "Solve: 5x − 3 = 2x + 12.",
  options: ["5", "4", "3", "6"],
  answer: "5"
},
{
  question: "Solve: 4(x − 2) = 3x + 5.",
  options: ["13", "12", "11", "10"],
  answer: "13"
},
{
  question: "Solve: (2x + 3)/5 = 7.",
  options: ["16", "17", "18", "19"],
  answer: "16"
},
{
  question: "Solve: 3x − 2 ≤ 10.",
  options: ["x ≤ 4", "x ≥ 4", "x ≤ 3", "x ≥ 3"],
  answer: "x ≤ 4"
},
{
  question: "Solve: 2x + 1 > 7.",
  options: ["x > 3", "x < 3", "x ≥ 3", "x ≤ 3"],
  answer: "x > 3"
},
{
  question: "Solve: −2x < 6.",
  options: ["x > -3", "x < -3", "x ≥ -3", "x ≤ -3"],
  answer: "x > -3"
},
{
  question: "Solve: 1 ≤ 3x − 2 ≤ 7.",
  options: ["1 ≤ x ≤ 3", "x ≤ 3", "x ≥ 1", "0 ≤ x ≤ 3"],
  answer: "1 ≤ x ≤ 3"
},
{
  question: "The sum of two consecutive integers is 25. Find them.",
  options: ["12 and 13", "11 and 14", "10 and 15", "9 and 16"],
  answer: "12 and 13"
},
{
  question: "A number is increased by 5 to give 17. Find the number.",
  options: ["12", "13", "11", "10"],
  answer: "12"
},
{
  question: "Twice a number minus 4 is 10. Find the number.",
  options: ["7", "6", "8", "9"],
  answer: "7"
},
{
  question: "The perimeter of a rectangle is 30 cm. If length is 8 cm, find width.",
  options: ["7 cm", "6 cm", "5 cm", "4 cm"],
  answer: "7 cm"
},
{
  question: "The sum of three consecutive integers is 36. Find the smallest.",
  options: ["11", "12", "13", "10"],
  answer: "11"
},
{
  question: "A father is 4 times as old as his son. Their total age is 50. Find the son's age.",
  options: ["10", "8", "12", "6"],
  answer: "10"
},
{
  question: "A number decreased by 3 gives twice the number. Find the number.",
  options: ["-3", "3", "0", "6"],
  answer: "-3"
},
{
  question: "Solve: 2(x + 3) − x = 9.",
  options: ["3", "4", "2", "5"],
  answer: "3"
},
{
  question: "Solve: (x − 1)/2 + (x + 3)/2 = 10.",
  options: ["9", "8", "7", "6"],
  answer: "9"
},
{
  question: "Solve: 3(x − 2) + 4(x + 1) = 5.",
  options: ["1", "2", "0", "-1"],
  answer: "1"
},
{
  question: "The difference between two numbers is 6 and their sum is 20. Find the larger number.",
  options: ["13", "12", "14", "10"],
  answer: "13"
},
{
  question: "Solve: 5 − 2x ≥ 1.",
  options: ["x ≤ 2", "x ≥ 2", "x ≤ -2", "x ≥ -2"],
  answer: "x ≤ 2"
},
{
  question: "A trader buys an item for GH₵50 and sells it for GH₵65. Find the profit.",
  options: ["GH₵15", "GH₵10", "GH₵20", "GH₵5"],
  answer: "GH₵15"
},

{
  question: "A bearing is measured from the:",
  options: ["North", "South", "East", "West"],
  answer: "North"
},
{
  question: "Express the bearing of East in degrees.",
  options: ["090°", "180°", "270°", "000°"],
  answer: "090°"
},
{
  question: "Express the bearing of South in degrees.",
  options: ["180°", "090°", "270°", "360°"],
  answer: "180°"
},
{
  question: "Find the reverse bearing of 060°.",
  options: ["240°", "120°", "300°", "180°"],
  answer: "240°"
},
{
  question: "Find the reverse bearing of 200°.",
  options: ["020°", "160°", "340°", "180°"],
  answer: "020°"
},
{
  question: "A point A is due East of B. What is the bearing of A from B?",
  options: ["090°", "270°", "180°", "000°"],
  answer: "090°"
},
{
  question: "A point B is due South of A. What is the bearing of B from A?",
  options: ["180°", "090°", "270°", "360°"],
  answer: "180°"
},
{
  question: "Which of the following is a vector quantity?",
  options: ["Speed", "Distance", "Velocity", "Time"],
  answer: "Velocity"
},
{
  question: "Which of the following is a scalar quantity?",
  options: ["Force", "Velocity", "Distance", "Acceleration"],
  answer: "Distance"
},
{
  question: "If vector A = (2,3) and B = (4,1), find A + B.",
  options: ["(6,4)", "(6,2)", "(2,4)", "(8,3)"],
  answer: "(6,4)"
},
{
  question: "If vector A = (5,2) and B = (1,3), find A − B.",
  options: ["(4,-1)", "(6,5)", "(4,1)", "(5,-1)"],
  answer: "(4,-1)"
},
{
  question: "Multiply vector (3,4) by 2.",
  options: ["(6,8)", "(5,6)", "(3,8)", "(6,4)"],
  answer: "(6,8)"
},
{
  question: "Find the magnitude of vector (3,4).",
  options: ["5", "7", "6", "4"],
  answer: "5"
},
{
  question: "Find the magnitude of vector (6,8).",
  options: ["10", "12", "14", "8"],
  answer: "10"
},
{
  question: "Two vectors are equal if they have the same:",
  options: ["Magnitude only", "Direction only", "Magnitude and direction", "Position"],
  answer: "Magnitude and direction"
},
{
  question: "Vectors are parallel if:",
  options: ["Their components are equal", "One is a scalar multiple of the other", "They are equal", "They are perpendicular"],
  answer: "One is a scalar multiple of the other"
},
{
  question: "Find vector AB if A(1,2) and B(4,6).",
  options: ["(3,4)", "(5,8)", "(4,6)", "(2,4)"],
  answer: "(3,4)"
},
{
  question: "Find the midpoint of vector from A(2,4) to B(6,8).",
  options: ["(4,6)", "(3,5)", "(5,7)", "(4,5)"],
  answer: "(4,6)"
},
{
  question: "If vector A = (x, y), what is −A?",
  options: ["(-x,-y)", "(x,-y)", "(-x,y)", "(y,x)"],
  answer: "(-x,-y)"
},
{
  question: "If AB + BC = AC, this represents:",
  options: ["Triangle law", "Parallel law", "Scalar law", "Gradient law"],
  answer: "Triangle law"
},

{
  question: "Which of the following is a measure of central tendency?",
  options: ["Range", "Mean", "Frequency", "Class"],
  answer: "Mean"
},
{
  question: "Find the mean of 2, 4, 6, 8.",
  options: ["5", "6", "4", "8"],
  answer: "5"
},
{
  question: "Find the mean of 3, 7, 5, 9, 6.",
  options: ["6", "7", "5", "8"],
  answer: "6"
},
{
  question: "Find the median of 2, 4, 6, 8, 10.",
  options: ["6", "5", "4", "8"],
  answer: "6"
},
{
  question: "Find the median of 3, 5, 7, 9.",
  options: ["6", "5", "7", "8"],
  answer: "6"
},
{
  question: "Find the mode of 2, 3, 3, 4, 5.",
  options: ["3", "2", "4", "5"],
  answer: "3"
},
{
  question: "Range is defined as:",
  options: ["Highest − Lowest", "Sum ÷ number", "Middle value", "Most frequent"],
  answer: "Highest − Lowest"
},
{
  question: "Find the range of 5, 7, 10, 15.",
  options: ["10", "8", "7", "15"],
  answer: "10"
},
{
  question: "If Σx = 50 and n = 10, find the mean.",
  options: ["5", "10", "6", "4"],
  answer: "5"
},
{
  question: "Which graph is best for grouped data?",
  options: ["Pie chart", "Histogram", "Bar chart", "Line graph"],
  answer: "Histogram"
},
{
  question: "Which graph is suitable for ungrouped data?",
  options: ["Histogram", "Pie chart", "None", "Frequency polygon"],
  answer: "Pie chart"
},
{
  question: "If the mean of 4 numbers is 10, find their total.",
  options: ["40", "20", "10", "50"],
  answer: "40"
},
{
  question: "The total frequency is 20 and Σfx = 200. Find the mean.",
  options: ["10", "20", "5", "15"],
  answer: "10"
},
{
  question: "What is the mode?",
  options: ["Most frequent value", "Middle value", "Average", "Difference"],
  answer: "Most frequent value"
},
{
  question: "Find the mean of 1, 2, 3, 4, 5, 6.",
  options: ["3.5", "3", "4", "2.5"],
  answer: "3.5"
},
{
  question: "If a class interval is 10–20, the width is:",
  options: ["10", "20", "5", "15"],
  answer: "10"
},
{
  question: "The midpoint of class 10–20 is:",
  options: ["15", "10", "20", "12"],
  answer: "15"
},
{
  question: "Which of the following shows frequency distribution?",
  options: ["Table", "Equation", "Graph", "Formula"],
  answer: "Table"
},
{
  question: "Find the mean of values with frequencies: x=2 (f=3), x=4 (f=2).",
  options: ["2.8", "3", "3.2", "4"],
  answer: "2.8"
},
{
  question: "If total frequency is 15 and Σfx = 90, find mean.",
  options: ["6", "5", "7", "4"],
  answer: "6"
},

{
  question: "Express 45 as a percentage of 60.",
  options: ["75%", "80%", "70%", "65%"],
  answer: "75%"
},
{
  question: "Increase 200 by 10%.",
  options: ["220", "210", "230", "240"],
  answer: "220"
},
{
  question: "Decrease 150 by 20%.",
  options: ["120", "130", "110", "100"],
  answer: "120"
},
{
  question: "Find 25% of 240.",
  options: ["60", "50", "40", "70"],
  answer: "60"
},
{
  question: "A price increases from GH₵50 to GH₵65. Find the percentage increase.",
  options: ["30%", "25%", "20%", "35%"],
  answer: "30%"
},
{
  question: "Express 0.35 as a percentage.",
  options: ["35%", "3.5%", "0.35%", "350%"],
  answer: "35%"
},
{
  question: "Divide 60 in the ratio 2:3.",
  options: ["24 and 36", "20 and 40", "30 and 30", "25 and 35"],
  answer: "24 and 36"
},
{
  question: "If A:B = 3:5 and A = 15, find B.",
  options: ["25", "20", "30", "35"],
  answer: "25"
},
{
  question: "Simplify the ratio 12:18.",
  options: ["2:3", "3:2", "4:6", "6:9"],
  answer: "2:3"
},
{
  question: "A map scale is 1:1000. What is 1 cm on the map in reality?",
  options: ["1000 cm", "100 cm", "10 cm", "10000 cm"],
  answer: "1000 cm"
},
{
  question: "Convert 72 km/h to m/s.",
  options: ["20 m/s", "18 m/s", "25 m/s", "15 m/s"],
  answer: "20 m/s"
},
{
  question: "A man travels 120 km in 2 hours. Find his speed.",
  options: ["60 km/h", "50 km/h", "40 km/h", "70 km/h"],
  answer: "60 km/h"
},
{
  question: "Find the simple interest on GH₵1000 at 10% per annum for 2 years.",
  options: ["GH₵200", "GH₵100", "GH₵300", "GH₵150"],
  answer: "GH₵200"
},
{
  question: "Find the amount on GH₵500 at 5% simple interest for 2 years.",
  options: ["GH₵550", "GH₵600", "GH₵525", "GH₵575"],
  answer: "GH₵550"
},
{
  question: "A trader buys an item for GH₵80 and sells it for GH₵100. Find the profit percentage.",
  options: ["25%", "20%", "30%", "15%"],
  answer: "25%"
},
{
  question: "An item is sold at GH₵90 after a 10% discount. Find the original price.",
  options: ["GH₵100", "GH₵95", "GH₵110", "GH₵105"],
  answer: "GH₵100"
},
{
  question: "A salesman earns 5% commission on GH₵2000 sales. Find his commission.",
  options: ["GH₵100", "GH₵200", "GH₵150", "GH₵50"],
  answer: "GH₵100"
},
{
  question: "Convert $50 to Ghana cedis if $1 = GH₵12.",
  options: ["GH₵600", "GH₵500", "GH₵650", "GH₵700"],
  answer: "GH₵600"
},
{
  question: "A population of 2000 people lives in an area of 10 km². Find the population density.",
  options: ["200 per km²", "100 per km²", "150 per km²", "250 per km²"],
  answer: "200 per km²"
},
{
  question: "If 5 workers complete a job in 10 days, how many days will 10 workers take?",
  options: ["5 days", "10 days", "2 days", "8 days"],
  answer: "5 days"
},

{
  question: "In a right-angled triangle, sin θ =:",
  options: ["Opp/Hyp", "Adj/Hyp", "Opp/Adj", "Hyp/Adj"],
  answer: "Opp/Hyp"
},
{
  question: "In a right-angled triangle, cos θ =:",
  options: ["Adj/Hyp", "Opp/Hyp", "Opp/Adj", "Hyp/Opp"],
  answer: "Adj/Hyp"
},
{
  question: "In a right-angled triangle, tan θ =:",
  options: ["Opp/Adj", "Adj/Opp", "Opp/Hyp", "Hyp/Adj"],
  answer: "Opp/Adj"
},
{
  question: "Find sin 30°.",
  options: ["1/2", "√3/2", "1", "0"],
  answer: "1/2"
},
{
  question: "Find cos 60°.",
  options: ["1/2", "√3/2", "1", "0"],
  answer: "1/2"
},
{
  question: "Find tan 45°.",
  options: ["1", "0", "√3", "1/2"],
  answer: "1"
},
{
  question: "Evaluate: sin²30° + cos²30°.",
  options: ["1", "1/2", "0", "2"],
  answer: "1"
},
{
  question: "Find sin 45°.",
  options: ["√2/2", "1/2", "√3/2", "1"],
  answer: "√2/2"
},
{
  question: "Find cos 45°.",
  options: ["√2/2", "1/2", "√3/2", "1"],
  answer: "√2/2"
},
{
  question: "Find tan 30°.",
  options: ["1/√3", "√3", "1", "1/2"],
  answer: "1/√3"
},
{
  question: "Find the value of x if sin x = 1.",
  options: ["90°", "0°", "45°", "60°"],
  answer: "90°"
},
{
  question: "Find the value of x if cos x = 0.",
  options: ["90°", "0°", "60°", "45°"],
  answer: "90°"
},
{
  question: "Find tan 60°.",
  options: ["√3", "1", "1/√3", "2"],
  answer: "√3"
},
{
  question: "A ladder leans against a wall making an angle of 30° with the ground. If the ladder is 10 m long, find the height reached.",
  options: ["5 m", "8.66 m", "10 m", "6 m"],
  answer: "5 m"
},
{
  question: "A tree subtends an angle of elevation of 45° from a point 10 m away. Find its height.",
  options: ["10 m", "5 m", "15 m", "20 m"],
  answer: "10 m"
},
{
  question: "From the top of a building, the angle of depression of a point on the ground is 30°. If the building is 20 m high, find the horizontal distance.",
  options: ["34.6 m", "20 m", "40 m", "10 m"],
  answer: "34.6 m"
},
{
  question: "Find the hypotenuse if opposite = 6 cm and θ = 30°.",
  options: ["12 cm", "10 cm", "8 cm", "6 cm"],
  answer: "12 cm"
},
{
  question: "If tan θ = 3/4, find sin θ.",
  options: ["3/5", "4/5", "5/3", "4/3"],
  answer: "3/5"
},
{
  question: "If sin θ = 5/13, find cos θ.",
  options: ["12/13", "5/12", "13/12", "12/5"],
  answer: "12/13"
},
{
  question: "Find θ if tan θ = 1.",
  options: ["45°", "30°", "60°", "90°"],
  answer: "45°"
},

{
  question: "Find the area of a rectangle with length 8 cm and width 5 cm.",
  options: ["40 cm²", "26 cm²", "13 cm²", "80 cm²"],
  answer: "40 cm²"
},
{
  question: "Find the perimeter of a rectangle with length 10 cm and width 4 cm.",
  options: ["28 cm", "40 cm", "20 cm", "14 cm"],
  answer: "28 cm"
},
{
  question: "Find the area of a triangle with base 6 cm and height 8 cm.",
  options: ["24 cm²", "48 cm²", "14 cm²", "30 cm²"],
  answer: "24 cm²"
},
{
  question: "Find the area of a circle of radius 7 cm (π = 22/7).",
  options: ["154 cm²", "44 cm²", "77 cm²", "100 cm²"],
  answer: "154 cm²"
},
{
  question: "Find the circumference of a circle of radius 7 cm (π = 22/7).",
  options: ["44 cm", "22 cm", "14 cm", "77 cm"],
  answer: "44 cm"
},
{
  question: "Find the area of a square of side 9 cm.",
  options: ["81 cm²", "36 cm²", "18 cm²", "72 cm²"],
  answer: "81 cm²"
},
{
  question: "Find the volume of a cube of side 5 cm.",
  options: ["125 cm³", "25 cm³", "100 cm³", "150 cm³"],
  answer: "125 cm³"
},
{
  question: "Find the surface area of a cube of side 4 cm.",
  options: ["96 cm²", "64 cm²", "48 cm²", "16 cm²"],
  answer: "96 cm²"
},
{
  question: "Find the volume of a cuboid of dimensions 5 cm, 4 cm, 3 cm.",
  options: ["60 cm³", "20 cm³", "12 cm³", "100 cm³"],
  answer: "60 cm³"
},
{
  question: "Find the total surface area of a cuboid of dimensions 2 cm, 3 cm, 4 cm.",
  options: ["52 cm²", "24 cm²", "48 cm²", "26 cm²"],
  answer: "52 cm²"
},
{
  question: "Find the volume of a cylinder with radius 7 cm and height 10 cm (π = 22/7).",
  options: ["1540 cm³", "770 cm³", "490 cm³", "3080 cm³"],
  answer: "1540 cm³"
},
{
  question: "Find the curved surface area of a cylinder of radius 7 cm and height 5 cm (π = 22/7).",
  options: ["220 cm²", "154 cm²", "308 cm²", "110 cm²"],
  answer: "220 cm²"
},
{
  question: "Find the volume of a sphere of radius 3 cm (π = 22/7).",
  options: ["113.14 cm³", "36 cm³", "144 cm³", "72 cm³"],
  answer: "113.14 cm³"
},
{
  question: "Find the surface area of a sphere of radius 7 cm (π = 22/7).",
  options: ["616 cm²", "308 cm²", "154 cm²", "700 cm²"],
  answer: "616 cm²"
},
{
  question: "Find the volume of a cone with radius 3 cm and height 6 cm (π = 22/7).",
  options: ["56.57 cm³", "113.14 cm³", "28.3 cm³", "75 cm³"],
  answer: "56.57 cm³"
},
{
  question: "Find the area of a trapezium with parallel sides 6 cm and 10 cm and height 5 cm.",
  options: ["40 cm²", "30 cm²", "50 cm²", "60 cm²"],
  answer: "40 cm²"
},
{
  question: "Find the area of a sector with angle 90° and radius 7 cm (π = 22/7).",
  options: ["38.5 cm²", "77 cm²", "49 cm²", "154 cm²"],
  answer: "38.5 cm²"
},
{
  question: "Find the length of an arc of 90° in a circle of radius 7 cm (π = 22/7).",
  options: ["11 cm", "22 cm", "14 cm", "7 cm"],
  answer: "11 cm"
},
{
  question: "Find the volume of a prism with base area 10 cm² and height 6 cm.",
  options: ["60 cm³", "16 cm³", "10 cm³", "50 cm³"],
  answer: "60 cm³"
},
{
  question: "Find the area of a parallelogram with base 8 cm and height 5 cm.",
  options: ["40 cm²", "20 cm²", "13 cm²", "80 cm²"],
  answer: "40 cm²"
},

{
  question: "Find the next term: 2, 4, 6, 8, ...",
  options: ["10", "12", "9", "11"],
  answer: "10"
},
{
  question: "Find the nth term of the sequence 3, 6, 9, 12, ...",
  options: ["3n", "n+3", "2n", "n²"],
  answer: "3n"
},
{
  question: "Find the 10th term of the sequence 2, 5, 8, 11, ...",
  options: ["29", "30", "32", "28"],
  answer: "29"
},
{
  question: "Find the sum of the first 5 terms of 2, 4, 6, 8, ...",
  options: ["30", "20", "25", "40"],
  answer: "30"
},
{
  question: "Find the sum of the first n terms of an arithmetic sequence with first term a and common difference d.",
  options: ["n/2(2a + (n−1)d)", "a + nd", "n(a + d)", "2a + nd"],
  answer: "n/2(2a + (n−1)d)"
},
{
  question: "Simplify: 2³ × 2⁴.",
  options: ["2⁷", "2¹²", "2¹", "2⁶"],
  answer: "2⁷"
},
{
  question: "Simplify: 3⁵ ÷ 3².",
  options: ["3³", "3⁷", "3²", "3⁵"],
  answer: "3³"
},
{
  question: "Simplify: (2³)².",
  options: ["2⁶", "2⁵", "2⁹", "2⁴"],
  answer: "2⁶"
},
{
  question: "Evaluate: 5⁰.",
  options: ["1", "0", "5", "Undefined"],
  answer: "1"
},
{
  question: "Simplify: 4⁻¹.",
  options: ["1/4", "4", "−4", "0"],
  answer: "1/4"
},
{
  question: "If log₁₀ 100 = x, find x.",
  options: ["2", "1", "10", "100"],
  answer: "2"
},
{
  question: "Find log₁₀ 1000.",
  options: ["3", "2", "1", "10"],
  answer: "3"
},
{
  question: "Simplify: log₁₀ 10⁴.",
  options: ["4", "10", "1", "0"],
  answer: "4"
},
{
  question: "If log₁₀ 2 = 0.3010, find log₁₀ 4.",
  options: ["0.6020", "0.3010", "0.9030", "0.1204"],
  answer: "0.6020"
},
{
  question: "If y varies directly as x and y = 10 when x = 2, find y when x = 5.",
  options: ["25", "20", "15", "30"],
  answer: "25"
},
{
  question: "If y varies inversely as x and y = 8 when x = 2, find y when x = 4.",
  options: ["4", "2", "6", "8"],
  answer: "4"
},
{
  question: "The probability of an event lies between:",
  options: ["0 and 1", "1 and 10", "−1 and 1", "0 and 10"],
  answer: "0 and 1"
},
{
  question: "Find the probability of getting a head when a fair coin is tossed.",
  options: ["1/2", "1", "0", "1/3"],
  answer: "1/2"
},
{
  question: "Find the probability of getting a 3 when a fair die is thrown.",
  options: ["1/6", "1/3", "1/2", "1/4"],
  answer: "1/6"
},
{
  question: "Two coins are tossed. Find the probability of getting two heads.",
  options: ["1/4", "1/2", "1/3", "1"],
  answer: "1/4"
},

{
  question: "Solve: x² − 5x + 6 = 0.",
  options: ["x = 2 or 3", "x = -2 or -3", "x = 1 or 6", "x = 0 or 6"],
  answer: "x = 2 or 3"
},
{
  question: "Solve: 2x² − 7x + 3 = 0.",
  options: ["x = 3 or 1/2", "x = -3 or -1/2", "x = 1 or 3", "x = 2 or 3"],
  answer: "x = 3 or 1/2"
},
{
  question: "If x + 1/x = 4, find x² + 1/x².",
  options: ["14", "16", "12", "10"],
  answer: "14"
},
{
  question: "Solve: log₁₀ x = 2.",
  options: ["100", "10", "2", "1000"],
  answer: "100"
},
{
  question: "Solve: log₁₀ x + log₁₀ 2 = 3.",
  options: ["500", "200", "100", "50"],
  answer: "500"
},
{
  question: "If sin θ = 3/5, find cos θ.",
  options: ["4/5", "5/4", "3/4", "2/5"],
  answer: "4/5"
},
{
  question: "Find tan θ if sin θ = 5/13.",
  options: ["5/12", "12/5", "13/5", "5/13"],
  answer: "5/12"
},
{
  question: "Solve: 2^x = 32.",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "Simplify: (x² − 9)/(x − 3) − (x + 3).",
  options: ["0", "6", "3", "-3"],
  answer: "0"
},
{
  question: "Find the gradient of a line perpendicular to y = 2x + 3.",
  options: ["-1/2", "2", "-2", "1/2"],
  answer: "-1/2"
},

{
  question: "Find the distance between (1,2) and (4,6).",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "If A(2,3) and B(6,7), find midpoint.",
  options: ["(4,5)", "(3,4)", "(5,6)", "(2,4)"],
  answer: "(4,5)"
},
{
  question: "Find the sum of first 10 terms of 3, 6, 9, ...",
  options: ["165", "150", "180", "120"],
  answer: "165"
},
{
  question: "Find the 8th term of sequence 2, 6, 18, ...",
  options: ["4374", "1296", "2187", "6561"],
  answer: "4374"
},
{
  question: "Solve: 3x − 2 ≤ 7 and x + 1 ≥ 3.",
  options: ["2 ≤ x ≤ 3", "x ≥ 2", "x ≤ 3", "x = 2"],
  answer: "2 ≤ x ≤ 3"
},
{
  question: "Find probability of picking a red ball from 3 red and 2 blue balls.",
  options: ["3/5", "2/5", "1/5", "4/5"],
  answer: "3/5"
},
{
  question: "Find the volume of a cylinder with r=3, h=7 (π=22/7).",
  options: ["198 cm³", "154 cm³", "210 cm³", "176 cm³"],
  answer: "198 cm³"
},
{
  question: "Find simple interest on GH₵2000 at 5% for 3 years.",
  options: ["GH₵300", "GH₵200", "GH₵400", "GH₵250"],
  answer: "GH₵300"
},
{
  question: "If y varies directly as x² and y=18 when x=3, find y when x=5.",
  options: ["50", "75", "60", "45"],
  answer: "50"
},

{
  question: "Solve: x² − 9x + 20 = 0.",
  options: ["x = 4 or 5", "x = 2 or 10", "x = 1 or 20", "x = 3 or 6"],
  answer: "x = 4 or 5"
},
{
  question: "Solve: 3x² − 12x = 0.",
  options: ["x = 0 or 4", "x = 3 or 4", "x = 1 or 12", "x = 2 or 6"],
  answer: "x = 0 or 4"
},
{
  question: "If x − 1/x = 3, find x² + 1/x².",
  options: ["11", "13", "9", "7"],
  answer: "11"
},
{
  question: "Simplify: log₁₀ 50 − log₁₀ 2.",
  options: ["log₁₀ 25", "log₁₀ 48", "log₁₀ 52", "log₁₀ 100"],
  answer: "log₁₀ 25"
},
{
  question: "Solve: log₁₀ (x − 1) = 1.",
  options: ["11", "10", "9", "12"],
  answer: "11"
},
{
  question: "If cos θ = 12/13, find sin θ.",
  options: ["5/13", "13/5", "12/5", "5/12"],
  answer: "5/13"
},
{
  question: "Find tan θ if cos θ = 5/13.",
  options: ["12/5", "5/12", "13/5", "5/13"],
  answer: "12/5"
},
{
  question: "Solve: 5^(x) = 125.",
  options: ["3", "2", "4", "5"],
  answer: "3"
},
{
  question: "Simplify: (x² − 4)/(x − 2) + (x + 2).",
  options: ["2x + 4", "x + 2", "2x", "x²"],
  answer: "2x + 4"
},
{
  question: "Find the gradient of a line perpendicular to y = −3x + 2.",
  options: ["1/3", "-1/3", "3", "-3"],
  answer: "1/3"
},
{
  question: "Find equation of line with gradient −2 passing through (1,3).",
  options: ["y = -2x + 5", "y = -2x + 1", "y = 2x + 5", "y = -2x - 5"],
  answer: "y = -2x + 5"
},
{
  question: "Find the 6th term of sequence 4, 7, 10, ...",
  options: ["19", "22", "25", "20"],
  answer: "19"
},
{
  question: "Find sum of first 8 terms of 5, 10, 15, ...",
  options: ["180", "200", "160", "150"],
  answer: "180"
},
{
  question: "Find the 5th term of geometric sequence 3, 6, 12, ...",
  options: ["48", "96", "24", "36"],
  answer: "48"
},
{
  question: "Solve: 2x − 3 < 5 ≤ x + 4.",
  options: ["4 ≤ x < 4", "x ≥ 4", "x < 4", "x > 4"],
  answer: "4 ≤ x < 4"
},
{
  question: "A bag contains 4 red, 3 blue, 3 green balls. Find probability of picking green.",
  options: ["3/10", "4/10", "3/7", "1/3"],
  answer: "3/10"
},
{
  question: "Find the area of a circle with diameter 14 cm (π=22/7).",
  options: ["154 cm²", "308 cm²", "44 cm²", "100 cm²"],
  answer: "154 cm²"
},
{
  question: "Find the volume of a cone with r=7, h=3 (π=22/7).",
  options: ["154 cm³", "308 cm³", "462 cm³", "98 cm³"],
  answer: "154 cm³"
},
{
  question: "If 2 men can complete a job in 6 days, how long will 3 men take?",
  options: ["4 days", "3 days", "6 days", "5 days"],
  answer: "4 days"
},
{
  question: "If y varies inversely as x² and y=8 when x=2, find y when x=4.",
  options: ["2", "1", "4", "3"],
  answer: "2"
},

{
  question: "Solve: x² − 7x + 10 = 0.",
  options: ["x = 5 or 2", "x = 10 or 1", "x = 3 or 4", "x = 6 or 1"],
  answer: "x = 5 or 2"
},
{
  question: "Solve: 4x² − 25 = 0.",
  options: ["x = ±5/2", "x = ±5", "x = ±25", "x = ±2/5"],
  answer: "x = ±5/2"
},
{
  question: "If x + 1/x = 6, find x² + 1/x².",
  options: ["34", "36", "30", "32"],
  answer: "34"
},
{
  question: "Simplify: log₁₀ 200 − log₁₀ 2.",
  options: ["log₁₀ 100", "log₁₀ 198", "log₁₀ 400", "log₁₀ 50"],
  answer: "log₁₀ 100"
},
{
  question: "Solve: log₁₀ (x + 2) = 2.",
  options: ["98", "100", "102", "96"],
  answer: "98"
},
{
  question: "If tan θ = 4/3, find sin θ.",
  options: ["4/5", "3/5", "5/4", "5/3"],
  answer: "4/5"
},
{
  question: "Find cos θ if tan θ = 5/12.",
  options: ["12/13", "5/13", "13/5", "12/5"],
  answer: "12/13"
},
{
  question: "Solve: 3^(x+1) = 81.",
  options: ["3", "2", "4", "5"],
  answer: "3"
},
{
  question: "Simplify: (x² − 1)/(x − 1) − (x + 1).",
  options: ["0", "2", "x", "-1"],
  answer: "0"
},
{
  question: "Find the gradient of a line perpendicular to y = 1/2 x + 3.",
  options: ["-2", "2", "-1/2", "1/2"],
  answer: "-2"
},
{
  question: "Find equation of line passing through (3,2) with gradient 4.",
  options: ["y = 4x - 10", "y = 4x + 2", "y = 2x + 4", "y = 4x - 2"],
  answer: "y = 4x - 10"
},
{
  question: "Find the 7th term of arithmetic sequence 1, 4, 7, ...",
  options: ["19", "21", "22", "20"],
  answer: "19"
},
{
  question: "Find the sum of first 12 terms of 2, 5, 8, ...",
  options: ["234", "240", "228", "250"],
  answer: "234"
},
{
  question: "Find the 6th term of geometric sequence 2, 4, 8, ...",
  options: ["64", "128", "32", "256"],
  answer: "64"
},
{
  question: "Solve: 3x − 4 ≥ 5 and 2x + 1 < 9.",
  options: ["3 ≤ x < 4", "x ≥ 3", "x < 4", "x > 3"],
  answer: "3 ≤ x < 4"
},
{
  question: "A bag contains 5 red, 4 blue, 1 green balls. Find probability of not picking blue.",
  options: ["6/10", "5/10", "4/10", "7/10"],
  answer: "6/10"
},
{
  question: "Find the area of a sector of 60° in a circle of radius 7 cm (π=22/7).",
  options: ["25.67 cm²", "49 cm²", "38.5 cm²", "77 cm²"],
  answer: "25.67 cm²"
},
{
  question: "Find the volume of a sphere of radius 7 cm (π=22/7).",
  options: ["1437.33 cm³", "1372 cm³", "1500 cm³", "1200 cm³"],
  answer: "1437.33 cm³"
},
{
  question: "If 4 workers complete a job in 6 days, how many days will 8 workers take?",
  options: ["3 days", "4 days", "2 days", "6 days"],
  answer: "3 days"
},
{
  question: "If y varies directly as x³ and y=16 when x=2, find y when x=4.",
  options: ["128", "64", "256", "96"],
  answer: "128"
},

{
  question: "Solve: x² − 4x − 12 = 0.",
  options: ["x = 6 or -2", "x = 4 or -3", "x = 3 or -4", "x = 2 or -6"],
  answer: "x = 6 or -2"
},
{
  question: "Solve: 2x² + 3x − 2 = 0.",
  options: ["x = 1/2 or -2", "x = 2 or -1/2", "x = 1 or -2", "x = -1 or 2"],
  answer: "x = 1/2 or -2"
},
{
  question: "If x + 1/x = 7, find x² + 1/x².",
  options: ["47", "49", "45", "50"],
  answer: "47"
},
{
  question: "Simplify: log₁₀ 500 − log₁₀ 5.",
  options: ["log₁₀ 100", "log₁₀ 495", "log₁₀ 250", "log₁₀ 50"],
  answer: "log₁₀ 100"
},
{
  question: "Solve: log₁₀ (2x) = 3.",
  options: ["500", "1000", "2000", "250"],
  answer: "500"
},
{
  question: "If sin θ = 8/17, find cos θ.",
  options: ["15/17", "8/15", "17/8", "15/8"],
  answer: "15/17"
},
{
  question: "Find tan θ if sin θ = 12/13.",
  options: ["12/5", "5/12", "13/12", "12/13"],
  answer: "12/5"
},
{
  question: "Solve: 4^(x) = 64.",
  options: ["3", "2", "4", "6"],
  answer: "3"
},
{
  question: "Simplify: (x² − 16)/(x − 4) − (x + 4).",
  options: ["0", "4", "8", "-4"],
  answer: "0"
},
{
  question: "Find the gradient of a line perpendicular to y = −1/3 x + 2.",
  options: ["3", "-3", "1/3", "-1/3"],
  answer: "3"
},
{
  question: "Find equation of line passing through (1,4) with gradient −3.",
  options: ["y = -3x + 7", "y = -3x + 4", "y = 3x + 7", "y = -3x - 7"],
  answer: "y = -3x + 7"
},
{
  question: "Find the 9th term of arithmetic sequence 2, 5, 8, ...",
  options: ["26", "29", "30", "28"],
  answer: "26"
},
{
  question: "Find the sum of first 15 terms of 1, 3, 5, ...",
  options: ["225", "200", "210", "180"],
  answer: "225"
},
{
  question: "Find the 7th term of geometric sequence 3, 6, 12, ...",
  options: ["192", "384", "96", "768"],
  answer: "192"
},
{
  question: "Solve: 2x − 1 ≥ 3 and 3x + 2 < 14.",
  options: ["2 ≤ x < 4", "x ≥ 2", "x < 4", "x > 2"],
  answer: "2 ≤ x < 4"
},
{
  question: "A bag contains 6 red, 2 blue, 2 green balls. Find probability of picking red or green.",
  options: ["8/10", "6/10", "4/10", "2/10"],
  answer: "8/10"
},
{
  question: "Find the area of a circle of radius 14 cm (π=22/7).",
  options: ["616 cm²", "308 cm²", "154 cm²", "700 cm²"],
  answer: "616 cm²"
},
{
  question: "Find the volume of a cylinder of radius 7 cm and height 14 cm (π=22/7).",
  options: ["2156 cm³", "1540 cm³", "3080 cm³", "1000 cm³"],
  answer: "2156 cm³"
},
{
  question: "If 6 men complete a job in 4 days, how many days will 3 men take?",
  options: ["8 days", "6 days", "4 days", "2 days"],
  answer: "8 days"
},
{
  question: "If y varies inversely as x and y=12 when x=2, find y when x=6.",
  options: ["4", "3", "6", "2"],
  answer: "4"
},

{
  question: "The angle at the centre of a circle is ______ the angle at the circumference standing on the same arc.",
  options: ["twice", "equal to", "half", "three times"],
  answer: "twice"
},
{
  question: "Angles in the same segment of a circle are:",
  options: ["equal", "supplementary", "complementary", "different"],
  answer: "equal"
},
{
  question: "The angle in a semicircle is:",
  options: ["90°", "180°", "60°", "45°"],
  answer: "90°"
},
{
  question: "Opposite angles of a cyclic quadrilateral are:",
  options: ["supplementary", "equal", "complementary", "different"],
  answer: "supplementary"
},
{
  question: "A point is rotated 90° anticlockwise about the origin. (x, y) becomes:",
  options: ["(-y, x)", "(y, -x)", "(-x, -y)", "(x, y)"],
  answer: "(-y, x)"
},
{
  question: "A reflection in the line y = x maps (2,3) to:",
  options: ["(3,2)", "(-2,-3)", "(2,-3)", "(-3,-2)"],
  answer: "(3,2)"
},
{
  question: "A translation by vector (3, -2) maps (1,4) to:",
  options: ["(4,2)", "(2,1)", "(3,2)", "(5,6)"],
  answer: "(4,2)"
},
{
  question: "An enlargement with scale factor 2 maps (2,3) to:",
  options: ["(4,6)", "(1.5,1)", "(2,6)", "(6,3)"],
  answer: "(4,6)"
},
{
  question: "Find 17 mod 5.",
  options: ["2", "3", "4", "1"],
  answer: "2"
},
{
  question: "Find 25 mod 6.",
  options: ["1", "5", "4", "3"],
  answer: "1"
},
{
  question: "Find (7 + 9) mod 5.",
  options: ["1", "2", "3", "4"],
  answer: "1"
},
{
  question: "Find (4 × 3) mod 5.",
  options: ["2", "3", "1", "4"],
  answer: "2"
},
{
  question: "Which of the following is a valid logical statement?",
  options: ["2 + 2 = 4", "x + y", "5x", "3y + 2"],
  answer: "2 + 2 = 4"
},
{
  question: "The statement 'All even numbers are divisible by 2' is:",
  options: ["True", "False", "Sometimes true", "Undefined"],
  answer: "True"
},
{
  question: "If P is true and Q is false, P AND Q is:",
  options: ["False", "True", "Undefined", "Sometimes true"],
  answer: "False"
},
{
  question: "If P is true and Q is false, P OR Q is:",
  options: ["True", "False", "Undefined", "Sometimes"],
  answer: "True"
},
{
  question: "Which measure of central tendency is most affected by extreme values?",
  options: ["Mean", "Median", "Mode", "Range"],
  answer: "Mean"
},
{
  question: "The cumulative frequency is used to draw:",
  options: ["Ogive", "Histogram", "Bar chart", "Pie chart"],
  answer: "Ogive"
},
{
  question: "The modal class is the class with:",
  options: ["Highest frequency", "Lowest frequency", "Middle value", "Zero frequency"],
  answer: "Highest frequency"
},
{
  question: "The median class is the class containing:",
  options: ["Middle value", "Highest value", "Lowest value", "Mean value"],
  answer: "Middle value"
}

];

export default coreMathsQuestions;
